import {
	CLEAR_INPUTSAVE,
	INPUTS_SAVED,
	INPUTS_SAVING,
	INPUTS_SAVING_FAILED
} from "../actions/types";
const initialState = {
	isSaving: false,
	isSaved: false,
	isFailed: false,
	id: ""
};
export default function(state = initialState, action) {
	switch (action.type) {
		case INPUTS_SAVING:
			return {
				...state,
				isSaving: true,
				isSaved: false,
				isFailed: false
			};
		case INPUTS_SAVED:
			return {
				...state,
				isSaving: false,
				isSaved: true,
				isFailed: false,
				id: action.payload
			};
		case INPUTS_SAVING_FAILED:
			return {
				...state,
				isSaving: false,
				isSaved: false,
				isFailed: true
			};
		case CLEAR_INPUTSAVE:
			return {
				...state,
				isSaving: false,
				isSaved: false,
				isFailed: false,
				id: ""
			};

		default:
			return state;
	}
}
